import { render, staticRenderFns } from "./QuestionThree.vue?vue&type=template&id=b9c8a28c&scoped=true&"
import script from "./QuestionThree.vue?vue&type=script&lang=js&"
export * from "./QuestionThree.vue?vue&type=script&lang=js&"
import style0 from "./QuestionThree.vue?vue&type=style&index=0&id=b9c8a28c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c8a28c",
  null
  
)

export default component.exports